import {nlsType} from '../core/components/nls'
declare global {
  interface Window {
    titles: {[lang: string]: {title: string; subTitle: string}}
  }
}
const bg = {
  app: {
    title: window.titles['bg'].title,
    subTitle: window.titles['bg'].subTitle
  }
}
const en = {
  app: {
    title: window.titles['en'].title,
    subTitle: window.titles['en'].subTitle
  }
}

export const nlss = {
  bg: bg,
  en: en
} as {[key: string]: any}

export const nls = {} as nlsType & typeof en
